
import React from 'react';
import { Input } from 'antd';

export default (props: { textoNarativa: string }) => {
    const { textoNarativa } = props;
    const { TextArea } = Input;

    return (
        <>
            <div className="ant-col ant-form-item-label">
                <label className="ant-form-item-no-colon" title="">
                    <span className="ant-app-text">Narrativa</span>
                </label>
            </div>
            <TextArea rows={8} value={textoNarativa} disabled />
        </>
    );
};
